import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from 'core/store/hooks';
import { update } from 'core/actions/admin/data';
import { EntityTypes } from 'constants/entities';
import { useCopyLink } from './useCopyLink';
import { ICourseProgressDAO } from 'types/domain/permissions';

export const useCourseProgressLink = (courseProgress?: ICourseProgressDAO, courseProgressId?: number) => {
  const [isCopy, setIsCopy] = useState(false);
  const dispatch = useAppDispatch();
  const { copyLinkToClipboard } = useCopyLink();

  const requestToken = useCallback(() => {
    if (!courseProgressId) return;
    dispatch(
      update({
        type: EntityTypes.COURSE_PROGRESS,
        mergeData: true,
        entity: { id: courseProgressId, generateToken: true },
      }),
    );
  }, [courseProgressId, dispatch]);

  useEffect(() => {
    if (courseProgress?.inviteUrl && isCopy) {
      copyLinkToClipboard(courseProgress.inviteUrl);
      setIsCopy(false);
    }
  }, [courseProgress, isCopy, copyLinkToClipboard]);

  const copyLink = useCallback(() => {
    setIsCopy(true);
    if (courseProgress?.inviteUrl) {
      copyLinkToClipboard(courseProgress.inviteUrl);
      setTimeout(() => setIsCopy(false), 500);
    } else {
      requestToken();
    }
  }, [courseProgress, requestToken, copyLinkToClipboard]);

  return { copyLink, isCopy };
};
